document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".assets_tabs .tab button");
  const tabContents = document.querySelectorAll(".tab_content_mainmarkting");

  function hideAllTabs() {
    tabContents.forEach(content => content.style.display = "none");
    tabs.forEach(tab => tab.classList.remove("active"));
  }

  function showTab(tabId) {
    console.log(tabId)
    if(tabId == "brochures_social_media-tab"){
      document.getElementById("photo_videos-tab").scrollIntoView({
        behavior: "smooth",
        block: "start", // Options: "start", "center", "end", "nearest"
      });
    }
    hideAllTabs();
    const tabContent = document.querySelector(`.tab_content_mainmarkting[data-id="${tabId}"]`);
    const tabButton = document.querySelector(`#${tabId} button`);

    if (tabContent && tabButton) {
      tabContent.style.display = "block";
      tabButton.classList.add("active");
    }
  }

  tabs.forEach(tab => {
    tab.addEventListener("click", function (event) {
      event.preventDefault();
      const tabId = this.parentNode.parentNode.id;
      const url = new URL(window.location);
console.log(url);
      url.searchParams.set("tab", tabId); // Only set the tab parameter
      window.history.replaceState(null, null, url);
      showTab(tabId);
      openAccordion(tabId); // Open the corresponding accordion
    });
  });

  const urlParams = new URLSearchParams(window.location.search);
  const initialTab = urlParams.get("tab");
  
  if (initialTab) {
    showTab(initialTab);
    openAccordion(initialTab); // Open the corresponding accordion when a tab is loaded
  } else if (tabs.length > 0) {
    tabs[0].click();
  }

  const groupOneButtons = document.querySelectorAll('.group_one .tab_button');
  const groupOneContents = document.querySelectorAll('.group_one_content');

  if (groupOneButtons.length > 0) {
    groupOneButtons[0].classList.add('active');
    if (groupOneContents.length > 0) {
      groupOneContents[0].style.display = 'block';
    }
  }

  groupOneButtons.forEach(button => {
    button.addEventListener('click', function() {
      const parentGroup = button.closest('.group_one');
      const targetClass = this.getAttribute('data-target');

      parentGroup.querySelectorAll('.tab_button').forEach(btn => {
        btn.classList.remove('active');
      });

      parentGroup.querySelectorAll('.group_one_content').forEach(content => {
        content.style.display = 'none';
      });

      const targetContent = parentGroup.querySelector(`.${targetClass}`);
      if (targetContent) {
        targetContent.style.display = 'block';
      }

      button.classList.add('active');
    });
  });

  const groupTwoButtons = document.querySelectorAll('.group_two .tab_button');
  const groupTwoContents = document.querySelectorAll('.group_two_content');

  if (groupTwoButtons.length > 0) {
    groupTwoButtons[0].classList.add('active');
    if (groupTwoContents.length > 0) {
      groupTwoContents[0].style.display = 'block';
    }
  }

  groupTwoButtons.forEach(button => {
    button.addEventListener('click', function() {
      const parentGroup = button.closest('.group_two');
      const targetClass = this.getAttribute('data-target');

      parentGroup.querySelectorAll('.tab_button').forEach(btn => {
        btn.classList.remove('active');
      });

      parentGroup.querySelectorAll('.group_two_content').forEach(content => {
        content.style.display = 'none';
      });

      const targetContent = parentGroup.querySelector(`.${targetClass}`);
      if (targetContent) {
        targetContent.style.display = 'block';
      }

      button.classList.add('active');
    });
  });

  const accordionTitles = document.querySelectorAll('.accordion_title');

  function openAccordion(targetId) {
    const contents = document.querySelectorAll('.accordian_content_main');
    contents.forEach(content => {
     const parentAccordion = content.closest('.accordian');
      if (content.getAttribute('data-id') === targetId) {
        setTimeout(() => {
          if (content.classList.contains('active')) {
            content.style.display = 'none';
            content.classList.remove('active');
            parentAccordion.classList.remove('active');
          } else {
            content.style.display = 'block';
            content.classList.add('active');
            parentAccordion.classList.add('active');
          }
        }, 100);
      } else {
        content.style.display = 'none';
        content.classList.remove('active');
        parentAccordion.classList.remove('active');
      }
    });
  }

  accordionTitles.forEach(title => {
    title.addEventListener('click', function () {
      const targetId = this.nextElementSibling.getAttribute('data-id');
      if (!this.classList.contains('active')) {
        openAccordion(targetId);
        showTab(targetId);
        const url = new URL(window.location);
        url.searchParams.set("tab", targetId);
        window.history.replaceState(null, null, url);
      }
    });
  });

  const accButtons = document.querySelectorAll(".acc_button");

  accButtons.forEach(button => {
  button.addEventListener("click", function () {
    const parent = this.closest(".accordian_main");
    const activeContent = parent.querySelector(".group_one_content, .group_two_content");
    const isActive = parent.classList.contains("active");

    setTimeout(() => {
      document.querySelectorAll(".group_one_content, .group_two_content").forEach(content => {
        content.style.display = "none";
        content.classList.remove("active");
      });
      document.querySelectorAll(".acc_title").forEach(title => {
        title.classList.remove("active");
      });
      document.querySelectorAll(".accordian_main").forEach(item => {
        item.classList.remove("active");
      });
  
      if (!isActive) {
        parent.classList.add("active");
        if (activeContent) {
          activeContent.style.display = "block";
          activeContent.classList.add("active");
        }
      }
    }, 100);
    
  });
});


  if (urlParams.has('tab')) {
    const targetTab = urlParams.get('tab');
    const targetAccordion = accordionTitles[0].nextElementSibling.getAttribute('data-id');
    showTab(targetTab);
    openAccordion(targetTab);
    accordionTitles.forEach(title => {
      if (title.nextElementSibling.getAttribute('data-id') === targetTab) {
        title.click();
      }
    });
  } else if (accordionTitles.length > 0) {
    const firstTitleId = accordionTitles[0].nextElementSibling.getAttribute('data-id');
    openAccordion(firstTitleId);
    showTab(firstTitleId);
  }
});

window.addEventListener("load", function() {
    const hash = window.location.hash; // Get the hash from the URL
  
    if (hash === "#social-media-templates") { // Check if the hash matches
        const targetElement = document.querySelector(hash);
        if (targetElement) {
            targetElement.scrollIntoView({ behavior: "smooth" }); // Smooth scroll to the target element
        }
    }
});